/* Easonlin storefront language selector.
   - page text is translated through the site's server-side DeepL proxy
   - IP geolocation chooses a language on a first visit (unless a manual choice exists)
   - all translations are cached in localStorage; English restores the original DOM */
(function () {
  'use strict';

  var API = 'https://carseatcoverspace.com/__translate.php';
  var GEO_API = 'https://carseatcoverspace.com/__geo.php';
  var MANUAL_KEY = 'easonlin.language.v1';
  var AUTO_KEY = 'easonlin.auto-language.v1';
  var CACHE_PREFIX = 'easonlin.i18n.v2.';
  var CACHE_DAYS = 90;
  var AUTO_DAYS = 1;
  var root = document.querySelector('[data-el-lang]');
  if (!root) return;

  var languages = [
    { target: 'EN', html: 'en', short: 'EN', label: 'English', english: 'English UK United States', flag: 'gb' },
    { target: 'ZH-HANS', html: 'zh-CN', short: '简', label: '简体中文', english: 'Chinese Simplified Mandarin', flag: 'cn' },
    { target: 'ZH-HANT', html: 'zh-TW', short: '繁', label: '繁體中文', english: 'Chinese Traditional Cantonese', flag: 'tw' },
    { target: 'JA', html: 'ja', short: 'JA', label: '日本語', english: 'Japanese', flag: 'jp' },
    { target: 'KO', html: 'ko', short: 'KO', label: '한국어', english: 'Korean', flag: 'kr' },
    { target: 'ES', html: 'es', short: 'ES', label: 'Español', english: 'Spanish Spain Latin America', flag: 'es' },
    { target: 'FR', html: 'fr', short: 'FR', label: 'Français', english: 'French France', flag: 'fr' },
    { target: 'DE', html: 'de', short: 'DE', label: 'Deutsch', english: 'German Germany', flag: 'de' },
    { target: 'IT', html: 'it', short: 'IT', label: 'Italiano', english: 'Italian Italy', flag: 'it' },
    { target: 'PT-BR', html: 'pt-BR', short: 'PT', label: 'Português (Brasil)', english: 'Portuguese Brazil', flag: 'br' },
    { target: 'PT-PT', html: 'pt-PT', short: 'PT', label: 'Português (Portugal)', english: 'Portuguese Portugal', flag: 'pt' },
    { target: 'NL', html: 'nl', short: 'NL', label: 'Nederlands', english: 'Dutch Netherlands', flag: 'nl' },
    { target: 'PL', html: 'pl', short: 'PL', label: 'Polski', english: 'Polish Poland', flag: 'pl' },
    { target: 'RU', html: 'ru', short: 'RU', label: 'Русский', english: 'Russian Russia', flag: 'ru' },
    { target: 'UK', html: 'uk', short: 'UK', label: 'Українська', english: 'Ukrainian Ukraine', flag: 'ua' },
    { target: 'BE', html: 'be', short: 'BE', label: 'Беларуская', english: 'Belarusian Belarus', flag: 'by' },
    { target: 'TR', html: 'tr', short: 'TR', label: 'Türkçe', english: 'Turkish Turkey', flag: 'tr' },
    { target: 'AR', html: 'ar', short: 'AR', label: 'العربية', english: 'Arabic Saudi Arabia UAE Egypt', flag: 'sa' },
    { target: 'HE', html: 'he', short: 'HE', label: 'עברית', english: 'Hebrew Israel', flag: 'il' },
    { target: 'FA', html: 'fa', short: 'FA', label: 'فارسی', english: 'Persian Farsi Iran', flag: 'ir' },
    { target: 'HI', html: 'hi', short: 'HI', label: 'हिन्दी', english: 'Hindi India', flag: 'in' },
    { target: 'UR', html: 'ur', short: 'UR', label: 'اردو', english: 'Urdu Pakistan', flag: 'pk' },
    { target: 'BN', html: 'bn', short: 'BN', label: 'বাংলা', english: 'Bengali Bangladesh India', flag: 'bd' },
    { target: 'TA', html: 'ta', short: 'TA', label: 'தமிழ்', english: 'Tamil India Sri Lanka', flag: 'in' },
    { target: 'TE', html: 'te', short: 'TE', label: 'తెలుగు', english: 'Telugu India', flag: 'in' },
    { target: 'ML', html: 'ml', short: 'ML', label: 'മലയാളം', english: 'Malayalam India', flag: 'in' },
    { target: 'MR', html: 'mr', short: 'MR', label: 'मराठी', english: 'Marathi India', flag: 'in' },
    { target: 'GU', html: 'gu', short: 'GU', label: 'ગુજરાતી', english: 'Gujarati India', flag: 'in' },
    { target: 'PA', html: 'pa', short: 'PA', label: 'ਪੰਜਾਬੀ', english: 'Punjabi India Pakistan', flag: 'in' },
    { target: 'NE', html: 'ne', short: 'NE', label: 'नेपाली', english: 'Nepali Nepal', flag: 'np' },
    { target: 'TH', html: 'th', short: 'TH', label: 'ไทย', english: 'Thai Thailand', flag: 'th' },
    { target: 'VI', html: 'vi', short: 'VI', label: 'Tiếng Việt', english: 'Vietnamese Vietnam', flag: 'vn' },
    { target: 'ID', html: 'id', short: 'ID', label: 'Bahasa Indonesia', english: 'Indonesian Indonesia', flag: 'id' },
    { target: 'MS', html: 'ms', short: 'MS', label: 'Bahasa Melayu', english: 'Malay Malaysia', flag: 'my' },
    { target: 'TL', html: 'tl', short: 'TL', label: 'Tagalog', english: 'Tagalog Filipino Philippines', flag: 'ph' },
    { target: 'JV', html: 'jv', short: 'JV', label: 'Basa Jawa', english: 'Javanese Indonesia', flag: 'id' },
    { target: 'SU', html: 'su', short: 'SU', label: 'Basa Sunda', english: 'Sundanese Indonesia', flag: 'id' },
    { target: 'MY', html: 'my', short: 'MY', label: 'မြန်မာ', english: 'Burmese Myanmar', flag: 'mm' },
    { target: 'SW', html: 'sw', short: 'SW', label: 'Kiswahili', english: 'Swahili Kenya Tanzania', flag: 'ke' },
    { target: 'AF', html: 'af', short: 'AF', label: 'Afrikaans', english: 'Afrikaans South Africa', flag: 'za' },
    { target: 'ZU', html: 'zu', short: 'ZU', label: 'isiZulu', english: 'Zulu South Africa', flag: 'za' },
    { target: 'XH', html: 'xh', short: 'XH', label: 'isiXhosa', english: 'Xhosa South Africa', flag: 'za' },
    { target: 'ST', html: 'st', short: 'ST', label: 'Sesotho', english: 'Sesotho Lesotho South Africa', flag: 'za' },
    { target: 'TN', html: 'tn', short: 'TN', label: 'Setswana', english: 'Tswana Botswana South Africa', flag: 'za' },
    { target: 'TS', html: 'ts', short: 'TS', label: 'Xitsonga', english: 'Tsonga South Africa', flag: 'za' },
    { target: 'MG', html: 'mg', short: 'MG', label: 'Malagasy', english: 'Malagasy Madagascar', flag: 'mg' },
    { target: 'MI', html: 'mi', short: 'MI', label: 'Te Reo Māori', english: 'Maori New Zealand', flag: 'nz' },
    { target: 'HA', html: 'ha', short: 'HA', label: 'Hausa', english: 'Hausa Nigeria', flag: 'ng' },
    { target: 'IG', html: 'ig', short: 'IG', label: 'Igbo', english: 'Igbo Nigeria', flag: 'ng' },
    { target: 'HY', html: 'hy', short: 'HY', label: 'Հայերեն', english: 'Armenian Armenia', flag: 'am' },
    { target: 'AZ', html: 'az', short: 'AZ', label: 'Azərbaycanca', english: 'Azerbaijani Azerbaijan', flag: 'az' },
    { target: 'KK', html: 'kk', short: 'KK', label: 'Қазақша', english: 'Kazakh Kazakhstan', flag: 'kz' },
    { target: 'KY', html: 'ky', short: 'KY', label: 'Кыргызча', english: 'Kyrgyz Kyrgyzstan', flag: 'kg' },
    { target: 'UZ', html: 'uz', short: 'UZ', label: 'Oʻzbekcha', english: 'Uzbek Uzbekistan', flag: 'uz' },
    { target: 'TG', html: 'tg', short: 'TG', label: 'Тоҷикӣ', english: 'Tajik Tajikistan', flag: 'tj' },
    { target: 'TK', html: 'tk', short: 'TK', label: 'Türkmençe', english: 'Turkmen Turkmenistan', flag: 'tm' },
    { target: 'MN', html: 'mn', short: 'MN', label: 'Монгол', english: 'Mongolian Mongolia', flag: 'mn' },
    { target: 'KA', html: 'ka', short: 'KA', label: 'ქართული', english: 'Georgian Georgia', flag: 'ge' },
    { target: 'PS', html: 'ps', short: 'PS', label: 'پښتو', english: 'Pashto Afghanistan Pakistan', flag: 'af' },
    { target: 'RO', html: 'ro', short: 'RO', label: 'Română', english: 'Romanian Romania', flag: 'ro' },
    { target: 'CS', html: 'cs', short: 'CS', label: 'Čeština', english: 'Czech Czech Republic', flag: 'cz' },
    { target: 'SK', html: 'sk', short: 'SK', label: 'Slovenčina', english: 'Slovak Slovakia', flag: 'sk' },
    { target: 'HU', html: 'hu', short: 'HU', label: 'Magyar', english: 'Hungarian Hungary', flag: 'hu' },
    { target: 'BG', html: 'bg', short: 'BG', label: 'Български', english: 'Bulgarian Bulgaria', flag: 'bg' },
    { target: 'EL', html: 'el', short: 'EL', label: 'Ελληνικά', english: 'Greek Greece', flag: 'gr' },
    { target: 'DA', html: 'da', short: 'DA', label: 'Dansk', english: 'Danish Denmark', flag: 'dk' },
    { target: 'SV', html: 'sv', short: 'SV', label: 'Svenska', english: 'Swedish Sweden', flag: 'se' },
    { target: 'NB', html: 'nb', short: 'NO', label: 'Norsk bokmål', english: 'Norwegian Norway', flag: 'no' },
    { target: 'FI', html: 'fi', short: 'FI', label: 'Suomi', english: 'Finnish Finland', flag: 'fi' },
    { target: 'IS', html: 'is', short: 'IS', label: 'Íslenska', english: 'Icelandic Iceland', flag: 'is' },
    { target: 'HR', html: 'hr', short: 'HR', label: 'Hrvatski', english: 'Croatian Croatia', flag: 'hr' },
    { target: 'SR', html: 'sr', short: 'SR', label: 'Српски', english: 'Serbian Serbia', flag: 'rs' },
    { target: 'SL', html: 'sl', short: 'SL', label: 'Slovenščina', english: 'Slovenian Slovenia', flag: 'si' },
    { target: 'LT', html: 'lt', short: 'LT', label: 'Lietuvių', english: 'Lithuanian Lithuania', flag: 'lt' },
    { target: 'LV', html: 'lv', short: 'LV', label: 'Latviešu', english: 'Latvian Latvia', flag: 'lv' },
    { target: 'ET', html: 'et', short: 'ET', label: 'Eesti', english: 'Estonian Estonia', flag: 'ee' },
    { target: 'SQ', html: 'sq', short: 'SQ', label: 'Shqip', english: 'Albanian Albania', flag: 'al' },
    { target: 'MK', html: 'mk', short: 'MK', label: 'Македонски', english: 'Macedonian North Macedonia', flag: 'mk' },
    { target: 'BS', html: 'bs', short: 'BS', label: 'Bosanski', english: 'Bosnian Bosnia', flag: 'ba' },
    { target: 'CA', html: 'ca', short: 'CA', label: 'Català', english: 'Catalan Spain', flag: 'es' },
    { target: 'GA', html: 'ga', short: 'GA', label: 'Gaeilge', english: 'Irish Ireland', flag: 'ie' },
    { target: 'MT', html: 'mt', short: 'MT', label: 'Malti', english: 'Maltese Malta', flag: 'mt' },
    { target: 'LB', html: 'lb', short: 'LB', label: 'Lëtzebuergesch', english: 'Luxembourgish Luxembourg', flag: 'lu' }
  ];
  var byTarget = {};
  languages.forEach(function (lang) { byTarget[lang.target] = lang; });
  var rtlTargets = { AR: 1, HE: 1, FA: 1, UR: 1, PS: 1 };
  var countryTargets = {
    US: 'EN', GB: 'EN', AU: 'EN', CA: 'EN', NZ: 'EN', IE: 'EN', SG: 'EN', ZA: 'EN',
    DE: 'DE', AT: 'DE', CH: 'DE', LI: 'DE', FR: 'FR', BE: 'NL', MC: 'FR', LU: 'FR',
    ES: 'ES', MX: 'ES', AR: 'ES', CO: 'ES', CL: 'ES', PE: 'ES', VE: 'ES', EC: 'ES',
    GT: 'ES', CU: 'ES', DO: 'ES', HN: 'ES', PY: 'ES', SV: 'ES', NI: 'ES', CR: 'ES',
    PA: 'ES', UY: 'ES', BO: 'ES', PR: 'ES', PT: 'PT-PT', BR: 'PT-BR', AO: 'PT-PT',
    MZ: 'PT-PT', CV: 'PT-PT', GW: 'PT-PT', ST: 'PT-PT', TL: 'PT-PT', IT: 'IT',
    SM: 'IT', VA: 'IT', NL: 'NL', PL: 'PL', RU: 'RU', BY: 'BE', KZ: 'KK', KG: 'KY',
    UA: 'UK', TR: 'TR', AZ: 'AZ', AM: 'HY', GE: 'KA', IL: 'HE', SA: 'AR', AE: 'AR',
    EG: 'AR', DZ: 'AR', MA: 'AR', TN: 'AR', LY: 'AR', JO: 'AR', LB: 'LB', KW: 'AR',
    QA: 'AR', BH: 'AR', OM: 'AR', YE: 'AR', IQ: 'AR', SY: 'AR', PS: 'PS', IR: 'FA',
    AF: 'PS', IN: 'HI', PK: 'UR', BD: 'BN', NP: 'NE', LK: 'TA', MM: 'MY', TH: 'TH',
    VN: 'VI', ID: 'ID', MY: 'MS', PH: 'TL', BN: 'MS', CN: 'ZH-HANS', HK: 'ZH-HANT',
    TW: 'ZH-HANT', MO: 'ZH-HANT', JP: 'JA', KR: 'KO', KP: 'KO', MN: 'MN', UZ: 'UZ',
    TM: 'TK', TJ: 'TG', RO: 'RO', MD: 'RO', CZ: 'CS', SK: 'SK', HU: 'HU', BG: 'BG',
    GR: 'EL', CY: 'EL', DK: 'DA', SE: 'SV', NO: 'NB', SJ: 'NB', FI: 'FI', IS: 'IS',
    HR: 'HR', RS: 'SR', ME: 'SR', SI: 'SL', LT: 'LT', LV: 'LV', EE: 'ET', AL: 'SQ',
    MK: 'MK', BA: 'BS', KE: 'SW', TZ: 'SW', UG: 'SW', RW: 'SW', NG: 'EN', GH: 'EN',
    ET: 'EN', SN: 'FR', CM: 'FR', CI: 'FR', MG: 'MG', MU: 'EN', MW: 'EN', ZM: 'EN',
    ZW: 'EN', BW: 'EN', NA: 'EN'
  };
  var manual = readStorage(MANUAL_KEY);
  if (manual && !byTarget[manual]) manual = null;
  var active = manual || 'EN';
  var applied = 'EN';
  var busy = false;
  var searchTimer = 0;
  var button = root.querySelector('.el-lang__button');
  var code = root.querySelector('[data-el-lang-code]');
  var flag = root.querySelector('[data-el-lang-flag]');
  var menu = root.querySelector('.el-lang__menu');
  var status = root.querySelector('[data-el-lang-status]');
  var optionsEl = root.querySelector('[data-el-lang-options]');
  var search = root.querySelector('[data-el-lang-search]');
  var empty = root.querySelector('[data-el-lang-empty]');
  var autoButton = root.querySelector('[data-el-lang-auto]');
  var sourceTexts = new WeakMap();
  var sourceAttrs = new WeakMap();
  var skipSelector = [
    'script', 'style', 'noscript', 'template', 'svg', 'canvas', 'iframe',
    'code', 'pre', '.el-lang', '.el-wa', '.notranslate', '[translate="no"]',
    '[data-no-translate]', '.logo-title', '.el-n', '.el-sp__code'
  ].join(',');
  var attrNames = ['placeholder', 'title', 'aria-label'];
  var optionButtons = [];

  function readStorage(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function writeStorage(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function removeStorage(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function hash(text) {
    var h = 2166136261;
    for (var i = 0; i < text.length; i++) {
      h ^= text.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0).toString(36) + '.' + text.length.toString(36);
  }

  function cacheKey(target, text) {
    return CACHE_PREFIX + target + '.' + hash(text);
  }

  function cacheGet(target, text) {
    try {
      var raw = localStorage.getItem(cacheKey(target, text));
      if (!raw) return null;
      var item = JSON.parse(raw);
      if (!item || typeof item.v !== 'string' || Date.now() - item.t > CACHE_DAYS * 86400000) {
        localStorage.removeItem(cacheKey(target, text));
        return null;
      }
      return item.v;
    } catch (e) { return null; }
  }

  function cacheSet(target, text, value) {
    try {
      localStorage.setItem(cacheKey(target, text), JSON.stringify({ v: value, t: Date.now() }));
    } catch (e) {}
  }

  function readAuto() {
    try {
      var item = JSON.parse(localStorage.getItem(AUTO_KEY) || 'null');
      if (!item || !item.target || !byTarget[item.target]) return null;
      if (Date.now() - item.t > AUTO_DAYS * 86400000) return null;
      return item;
    } catch (e) { return null; }
  }

  function saveAuto(target) {
    writeStorage(AUTO_KEY, JSON.stringify({ target: target, t: Date.now() }));
  }

  function hasLetters(text) {
    return /[A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF\u0590-\u05FF\u0600-\u06FF\u0900-\u0DFF\u0E00-\u0EFF\u1000-\u109F\u3040-\u30FF\u3400-\u9FFF\uAC00-\uD7AF]/.test(text);
  }

  function shouldSkip(text) {
    var value = text.trim();
    if (value.length < 2 || value.length > 1200 || !hasLetters(value)) return true;
    if (/^(?:https?:\/\/|www\.|mailto:|\S+@\S+\.\S+)/i.test(value)) return true;
    return false;
  }

  function splitWhitespace(raw) {
    var lead = (raw.match(/^\s*/) || [''])[0];
    var trail = (raw.match(/\s*$/) || [''])[0];
    return { lead: lead, trail: trail, core: raw.slice(lead.length, raw.length - trail.length) };
  }

  function collect() {
    var groups = new Map();
    var attributes = [];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || parent.closest(skipSelector)) return NodeFilter.FILTER_REJECT;
        var raw = sourceTexts.has(node) ? sourceTexts.get(node) : node.nodeValue;
        var parts = splitWhitespace(raw || '');
        if (shouldSkip(parts.core)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (!sourceTexts.has(node)) sourceTexts.set(node, node.nodeValue || '');
      var raw = sourceTexts.get(node);
      var parts = splitWhitespace(raw);
      if (!groups.has(parts.core)) groups.set(parts.core, []);
      groups.get(parts.core).push({ kind: 'text', node: node, lead: parts.lead, trail: parts.trail });
    }
    var titleNode = document.querySelector('title');
    if (titleNode && titleNode.firstChild && !shouldSkip(titleNode.textContent)) {
      if (!sourceTexts.has(titleNode.firstChild)) sourceTexts.set(titleNode.firstChild, titleNode.textContent);
      var titleParts = splitWhitespace(sourceTexts.get(titleNode.firstChild));
      if (!groups.has(titleParts.core)) groups.set(titleParts.core, []);
      groups.get(titleParts.core).push({ kind: 'title', lead: titleParts.lead, trail: titleParts.trail });
    }
    document.querySelectorAll('[placeholder], [title], [aria-label]').forEach(function (el) {
      if (el.closest(skipSelector)) return;
      var stored = sourceAttrs.get(el) || {};
      attrNames.forEach(function (name) {
        if (!el.hasAttribute(name)) return;
        if (!stored[name]) stored[name] = el.getAttribute(name);
        var raw = stored[name] || '';
        if (shouldSkip(raw)) return;
        sourceAttrs.set(el, stored);
        var entry = { kind: 'attr', el: el, name: name, text: raw.trim() };
        attributes.push(entry);
        if (!groups.has(raw.trim())) groups.set(raw.trim(), []);
        groups.get(raw.trim()).push(entry);
      });
    });
    return { groups: groups };
  }

  function batches(texts) {
    var result = [];
    var current = [];
    var chars = 0;
    texts.forEach(function (text) {
      if (current.length >= 40 || chars + text.length > 5400) {
        if (current.length) result.push(current);
        current = [];
        chars = 0;
      }
      current.push(text);
      chars += text.length;
    });
    if (current.length) result.push(current);
    return result;
  }

  async function requestBatch(target, texts) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 25000);
    try {
      var response = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ target: target, texts: texts }),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var payload = await response.json();
      if (!payload || !payload.ok || !Array.isArray(payload.translations) || payload.translations.length !== texts.length) {
        throw new Error('Invalid translation response');
      }
      return payload.translations;
    } finally {
      clearTimeout(timeout);
    }
  }

  async function translate(target, groups) {
    var values = new Map();
    var missing = [];
    groups.forEach(function (entries, text) {
      var cached = cacheGet(target, text);
      if (cached !== null) values.set(text, cached);
      else missing.push(text);
    });
    var chunks = batches(missing);
    for (var i = 0; i < chunks.length; i++) {
      var translated = await requestBatch(target, chunks[i]);
      chunks[i].forEach(function (text, index) {
        var value = translated[index];
        if (typeof value === 'string') {
          values.set(text, value);
          cacheSet(target, text, value);
        }
      });
    }
    return values;
  }

  function apply(target, groups, values) {
    var isEnglish = target === 'EN';
    groups.forEach(function (entries, text) {
      entries.forEach(function (entry) {
        var value = isEnglish ? text : values.get(text);
        if (typeof value !== 'string') return;
        if (entry.kind === 'text') entry.node.nodeValue = entry.lead + value + entry.trail;
        if (entry.kind === 'title') document.title = entry.lead + value + entry.trail;
        if (entry.kind === 'attr') entry.el.setAttribute(entry.name, value);
      });
    });
    document.documentElement.lang = byTarget[target].html;
    document.documentElement.dir = rtlTargets[target] ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('data-el-locale', target);
  }

  function setBusy(value) {
    busy = value;
    root.classList.toggle('is-loading', value);
    button.setAttribute('aria-busy', value ? 'true' : 'false');
    if (value) status.textContent = 'Translating…';
  }

  function updateUi(target) {
    var meta = byTarget[target] || byTarget.EN;
    code.textContent = meta.short;
    if (flag.getAttribute('src') !== 'https://flagcdn.com/w40/' + meta.flag + '.png') {
      flag.src = 'https://flagcdn.com/w40/' + meta.flag + '.png';
    }
    flag.alt = '';
    button.setAttribute('aria-label', 'Select language, current ' + meta.label);
    optionButtons.forEach(function (option) {
      option.setAttribute('aria-selected', String(option.dataset.elLangTarget === target));
    });
    if (autoButton) autoButton.setAttribute('aria-pressed', String(manual === null));
    status.textContent = '';
    document.documentElement.lang = meta.html;
    document.documentElement.dir = rtlTargets[target] ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('data-el-locale', target);
  }

  function buildOptions() {
    if (optionButtons.length) return;
    optionButtons = languages.map(function (meta) {
      var option = document.createElement('button');
      option.type = 'button';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.dataset.elLangTarget = meta.target;
      option.dataset.search = (meta.label + ' ' + meta.english + ' ' + meta.target + ' ' + meta.short).toLowerCase();
      option.innerHTML = '<img src="https://flagcdn.com/w40/' + meta.flag + '.png" width="22" height="16" loading="lazy" decoding="async" alt=""><span class="el-lang__name" dir="auto">' + meta.label + '</span><span class="el-lang__option-code">' + meta.short + '</span>';
      optionsEl.appendChild(option);
      return option;
    });
  }

  function filterOptions() {
    var query = (search.value || '').trim().toLowerCase();
    var visible = 0;
    optionButtons.forEach(function (option) {
      var match = !query || option.dataset.search.indexOf(query) !== -1;
      option.hidden = !match;
      if (match) visible++;
    });
    empty.hidden = visible > 0;
    if (autoButton) autoButton.hidden = !!query;
  }

  function closeMenu() {
    root.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  }

  function openMenu() {
    buildOptions();
    root.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    search.value = '';
    filterOptions();
    window.setTimeout(function () { search.focus(); }, 20);
  }

  async function resolveAuto(force) {
    if (!force) {
      var cached = readAuto();
      if (cached) return cached.target;
    }
    var country = '';
    try {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 6000);
      var response = await fetch(GEO_API, { headers: { 'Accept': 'application/json' }, signal: controller.signal, cache: 'no-store' });
      clearTimeout(timeout);
      if (response.ok) {
        var payload = await response.json();
        country = String(payload.country || '').toUpperCase();
      }
    } catch (e) {}
    var target = countryTargets[country] || browserTarget() || 'EN';
    saveAuto(target);
    return target;
  }

  function browserTarget() {
    var lang = (navigator.language || 'en').toLowerCase();
    if (lang.indexOf('zh-tw') === 0 || lang.indexOf('zh-hk') === 0) return 'ZH-HANT';
    if (lang.indexOf('zh') === 0) return 'ZH-HANS';
    if (lang.indexOf('pt-br') === 0) return 'PT-BR';
    if (lang.indexOf('pt') === 0) return 'PT-PT';
    var base = lang.split('-')[0].toUpperCase();
    var aliases = { PT: 'PT-PT', NB: 'NB', NO: 'NB', IW: 'HE', FIL: 'TL' };
    if (aliases[base]) base = aliases[base];
    return byTarget[base] ? base : 'EN';
  }

  function isBot() {
    if (navigator.webdriver) return true;
    return /lighthouse|pagespeed|googlebot|bingbot|yandexbot|baiduspider|headlesschrome/i.test(navigator.userAgent || '');
  }

  async function runTarget(target, mode) {
    if (!byTarget[target]) target = 'EN';
    var previousManual = manual;
    setBusy(true);
    try {
      var collected = collect();
      var values = target === 'EN' ? new Map() : await translate(target, collected.groups);
      apply(target, collected.groups, values);
      active = target;
      applied = target;
      if (mode === 'manual') {
        manual = target;
        writeStorage(MANUAL_KEY, target);
      } else if (mode === 'auto') {
        manual = null;
        saveAuto(target);
      }
      updateUi(target);
    } catch (error) {
      active = applied;
      manual = previousManual;
      updateUi(manual || applied);
      status.textContent = 'Translation unavailable. Please try again.';
      if (window.console && console.warn) console.warn('Language switch failed:', error.message);
    } finally {
      setBusy(false);
    }
  }

  function choose(target) {
    if (busy || !byTarget[target]) return;
    closeMenu();
    if (target === active) {
      manual = target;
      writeStorage(MANUAL_KEY, target);
      updateUi(target);
      return;
    }
    runTarget(target, 'manual');
  }

  async function chooseAuto() {
    if (busy) return;
    closeMenu();
    removeStorage(MANUAL_KEY);
    manual = null;
    setBusy(true);
    try {
      var target = await resolveAuto(true);
      await runTarget(target, 'auto');
    } finally {
      setBusy(false);
    }
  }

  button.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (busy) return;
    if (root.classList.contains('is-open')) closeMenu();
    else openMenu();
  });

  optionsEl.addEventListener('click', function (event) {
    var option = event.target.closest('[data-el-lang-target]');
    if (option) choose(option.dataset.elLangTarget);
  });
  if (autoButton) autoButton.addEventListener('click', chooseAuto);
  search.addEventListener('input', filterOptions);
  search.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { closeMenu(); return; }
    if (event.key === 'ArrowDown' || event.key === 'Enter') {
      var first = optionButtons.filter(function (option) { return !option.hidden; })[0];
      if (first) {
        event.preventDefault();
        if (event.key === 'Enter') first.click();
        else first.focus();
      }
    }
  });
  optionsEl.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var visible = optionButtons.filter(function (option) { return !option.hidden; });
    var current = visible.indexOf(document.activeElement);
    var step = event.key === 'ArrowDown' ? 1 : -1;
    var next = current < 0 ? 0 : (current + step + visible.length) % visible.length;
    if (visible[next]) { event.preventDefault(); visible[next].focus(); }
  });
  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) closeMenu();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  updateUi(active);
  if (isBot()) return;
  if (manual) {
    applied = 'EN';
    runTarget(manual, 'manual');
  } else {
    var cached = readAuto();
    if (cached) runTarget(cached.target, 'auto');
    else chooseAuto();
  }
})();
